import React, { Component } from 'react'
import './style.css'

export default class Mustom extends Component {
    state = { isAlert : true }

    closeFx = () => {
        this.setState(
            { isAlert : false }
        )
    }

    render() {
        const Banner = {
            backgroundImage: 'url("/pcart.png")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundAttachment: 'fixed',
            height: '100vh'
        }

        return (
            <React.Fragment>
            	<div className='WideBanner' style={ Banner }>
                    <div id='pcartContainer'>
                        <div id='pcartTxt'>
                            <h1>MUSTOM, More than Custom</h1>
                            <p>Mustom is my after-work project.</p>
                            <p>You can feel free to use it since I've released all the code under the open-source AGPL v3 license.</p>
                        </div>
                        <div id='pcartBtn' onClick={ () => window.open('https://mustom.com', '_blank') }>
                            <span>Project Home</span>
                        </div>
                    </div>
                </div>
			</React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/mustom/index.js